module.exports = __webpack_public_path__ + "static/img/sexual_violence_3.7641ae7a.png";